"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.fruitPalette = exports.microPalette = exports.win32Palette = exports.startupPalette = exports.materialPalette = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var materialPalette = ['#e57373', '#f06292', '#ba68c8', '#9575cd', '#7986cb', '#64b5f6', '#4fc3f7', '#4dd0e1', '#4db6ac', '#81c784', '#aed581', '#dce775', '#fff176', '#ffd54f', '#ffb74d', '#ff8a65', '#a1887f', '#e0e0e0', '#90a4ae'];
exports.materialPalette = materialPalette;
var startupPalette = ['#32325d', '#3297d3', '#3ecf8e', '#5969e2', '#6772e5', '#87bbfd', '#87bbfd', '#8898aa', '#d6facf', '#d782d9', '#f5be58'];
exports.startupPalette = startupPalette;
var win32Palette = ['#e3575f', '#394dcd', '#dfe300', '#208c71', '#6c6c6c'];
exports.win32Palette = win32Palette;
var microPalette = ['#f65314', '#7cbb00', '#00a1f1', '#ffbb00', '#737373'];
exports.microPalette = microPalette;
var fruitPalette = ['#61bb46', '#fdb827', '#f5821f', '#e03a3e', '#963d97'];
/**
 * Calculates a hash number for a given string
 */

exports.fruitPalette = fruitPalette;

var hashString = function hashString(str) {
  var sum = str.split('').map(function (char) {
    return char.charCodeAt(0);
  }).reduce(function () {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 ? arguments[1] : undefined;
    return x * y;
  });
  sum += str.length;
  return sum;
};
/**
 * use the hash to obtain a color from a palette
 */


var getColorForString = function getColorForString(str, colors) {
  return colors[hashString(str) % colors.length];
};
/**
 * Gets initials: e.g. Armando Sosa -> AS
 *
 * TODO: Handle Special Cases.
 */


var initials = function initials(str) {
  return str.toUpperCase().split(' ').map(function (str) {
    return str.substr(0, 1);
  }).join('').substr(0, 3);
};
/**
 * Creates an avatar
 */


var Unavatar = function Unavatar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 40 : _ref$size,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? null : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? null : _ref$id,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'unavatar' : _ref$className,
      _ref$palette = _ref.palette,
      palette = _ref$palette === void 0 ? materialPalette : _ref$palette;

  if (!name) {
    return null;
  }

  if (!id) {
    id = name;
  }

  var backgroundColor = getColorForString(name, palette);

  var color = _tinycolor.default.mostReadable(backgroundColor, palette);

  return _react.default.createElement("div", {
    className: className,
    style: {
      backgroundColor: backgroundColor,
      color: color,
      height: "".concat(size, "px"),
      width: "".concat(size, "px"),
      borderRadius: "".concat(size / 2, "px"),
      fontSize: "".concat(size * 0.4, "px"),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: 0,
      padding: 0
    }
  }, initials(name));
};

Unavatar.propTypes = {
  palette: _propTypes.default.arrayOf(_propTypes.default.string)
};
var _default = Unavatar;
exports.default = _default;